import { render } from "./App.vue?vue&type=template&id=bbe9861c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bbe9861c&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-register-student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__